import React from 'react';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';
import { withRouter } from 'react-router-dom';

import MapMenu from './MapMenu';

@inject('dataStore')
@inject('commonStore')
@observer
class SidebarMenu extends React.Component {
  static propTypes = {
    commonStore: PropTypes.object.isRequired,
  };

  render() {
    const { commonStore } = this.props;

    return (
      <nav id="menu" className={commonStore.isSidebarActive ? 'open' : ''}>
        <MapMenu />
      </nav>
    );
  }
}

export default withRouter(SidebarMenu);



// WEBPACK FOOTER //
// ./src/components/SidebarMenu.js